<h1 mat-dialog-title>{{ 'labels.heading.Change Password' | translate }}</h1>

<div mat-dialog-content>
  <form [formGroup]="changePasswordForm">
    <div class="layout-column">
      <LOSx-input-password
        #password
        formControlName="password"
        label="{{ 'Password' | translateKey: 'inputs' }}"
      ></LOSx-input-password>
      <mat-error>
        @if (
          changePasswordForm.get('password').errors?.['uppercase'] ||
          changePasswordForm.get('password').errors?.['number'] ||
          changePasswordForm.get('password').errors?.['repeated'] ||
          changePasswordForm.get('password').errors?.['specialChar'] ||
          changePasswordForm.get('password').errors?.['minlength']
        ) {
          <p>
            {{ 'labels.commons.Password validation' | translate: { minchar: minPasswordLength } }}
          </p>
        }
      </mat-error>

      <LOSx-input-password
        #repeatPassword
        formControlName="repeatPassword"
        label="{{ 'Confirm Password' | translateKey: 'inputs' }}"
      ></LOSx-input-password>
    </div>

    <div class="error">
      @if (changePasswordForm.get('repeatPassword').errors?.['notequal']) {
        <p>
          {{ 'Passwords do not match' | translateKey: 'inputs' }}
        </p>
      }
    </div>
  </form>
</div>

<mat-dialog-actions align="center">
  <button mat-raised-button mat-dialog-close>{{ 'labels.buttons.Cancel' | translate }}</button>
  <button
    mat-raised-button
    color="warn"
    [disabled]="!changePasswordForm.valid"
    [mat-dialog-close]="{
      password: changePasswordForm.get('password').value,
      repeatPassword: changePasswordForm.get('repeatPassword').value
    }"
  >
    {{ 'labels.buttons.Confirm' | translate }}
  </button>
</mat-dialog-actions>
